import { type ClientInferRequest } from "@ts-rest/core";

import { client } from "~/api/client";

import { type apiContract } from "../contract";

export type GetTillUserRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.getUser
>;

export async function getUser(
  tillId: string,
  query: GetTillUserRequest["query"]
) {
  const response = await client.v1.pos.tills.getUser({
    params: {
      tillId
    },
    query
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}
